import ChatRoom from "./component/ChatRoom";

function App() {
  return (
    <ChatRoom />
  );
}

export default App;
